







import {
  Prop,
  Vue,
  Component
} from "@/shared/vuepack";

import { formatCurrency } from "@/shared/currency";

@Component
export default class CurrencyAmount extends Vue {

  @Prop()
  value: number;

  @Prop({default: () => []})
  classes: string[];

  formatCurrency = formatCurrency;

  get isNegative () {
    return this.value < 0;
  }

}
